/**
 * 登录图片验证码
 * @returns {string}
 */
export const userImgCode = () => {
  let timestamp = new Date().getTime()
  return `/credit/captcha?_=${timestamp}`
}
